import React from "react";
import {useTranslation} from "react-i18next";
import {Text,View,} from "@react-pdf/renderer";
import {styles} from "./Styles/Styles";
import dateFormat from "dateformat";

const selectedEntry = (data) => {
    return (<>
        <Text>
            {data.number} {data.street}
        </Text>
        <Text>
            {data.post_code} {data.place}
        </Text>
        <Text>
            {data.country}
        </Text>
    </>)
}

const Recipient = ({ client, firm, docDate }) => {
    const { t } = useTranslation();
    let recipient_name = undefined
    let recipient_address = undefined

    if (firm && firm.name) {
        recipient_name = (<>
            <Text style={styles.text}>
                {firm.name}
            </Text>
            <Text style={styles.text}>
                {client.client_data.first_name} {client.client_data.last_name}
            </Text>
        </>)
        recipient_address = selectedEntry(firm)
    } else {
        recipient_name = (
        <Text style={styles.text}>
            {client.client_data.first_name} {client.client_data.last_name}
        </Text>
        )
        recipient_address = selectedEntry(client.client_data)
    }

    return (
        <View style={styles.titleContainer}>
            <View style={{width: '50%'}}>
                <Text style={styles.text}>
                    {t("offer.pdf_document.texts.lu_country")}, {dateFormat(docDate, "dd.mm.yyyy")}
                </Text>
            </View>
            <View style={{width: '50%'}}>
                <View style={styles.rightContent}>
                    <Text style={styles.redTitle}>
                        {t("offer.pdf_document.texts.recipient")}
                    </Text>
                    {recipient_name}
                    {recipient_address}
                </View>
            </View>
        </View>
    );
}

export default Recipient;
